<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form custom-form-1">
        <div class="search-form-box">
          <div class="left-box">
            <div class="center-box-1">
              <el-image :src="carImage" class="car-img"></el-image>
              <span class="center-name">{{ form.carNumber }} {{ form.username }}</span>
            </div>

            <div class="center-box-2">
              {{ form.vehicleMode }}
            </div>
            <div class="center-box-2">{{ form.vehicleLength }}米</div>
            <div class="center-box-2" @click="checkOrder(item)">当前订单：{{ form.currentOrder }}条</div>
            <div class="center-box-2">
              剩余容量：
              <span class="color52C41A">
                {{ form.marginVolume<0?0:form.marginVolume }}方/{{ form.marginWeight<0?0:form.marginWeight }}吨
              </span>
            </div>
          </div>
        </div>
        <custom-table
          :data="tableData"
          :column="tableColumn"
          height="auto"
          :loading="tableOptions.loading"
          :selection="false"
          :showPagination="false">
          <template v-slot:weight="{ row }">
            <span>{{ row.weight }}{{ row.wightUnit ? "吨" : "公斤" }}</span>
          </template>
          <template v-slot:driverFee="{ row }">
            <span>{{ row.driverFee }}元</span>
          </template>
          <template v-slot:startCityName="{ row }">
            <span>{{ row.startCityName }}{{ row.startDistrictName }}</span>
          </template>
          <template v-slot:endCityName="{ row }">
            <span>{{ row.endCityName }}{{ row.endDistrictName }}</span>
          </template>
        </custom-table>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { getDriverCurrentOrder } from "./api";
import CustomTable from "@/components/CustomTable.vue";
export default {
  name: "HistoricalRecords",
  components: {
    DialogContainer,
    CustomTable,
  },
  data() {
    return {
      carImage: require("@/assets/imgs/title.png"),
      tableOptions: {
        loading: false,
        currentPage: 1,
        pageCount: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0,
      },
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "70%",
        show: false,
        title: "承接订单信息",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {},
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "货物名称",
          prop: "cargoName",
          align: "left",
          show: true,
        },
        {
          label: "净运费",
          prop: "driverFee",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "装货地",
          prop: "startCityName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "卸货地",
          prop: "endCityName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "重量",
          prop: "weight",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "体积(m³)",
          prop: "volume",
          align: "left",
          show: true,
        },
        {
          label: "派单时间",
          prop: "dispatchTime",

          align: "left",
          show: true,
        },
      ],
      tableData: [],
    };
  },

  mounted() {},
  methods: {
    getTableData(driverId) {
      getDriverCurrentOrder(driverId).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    init(row) {
      this.form = Object.assign({}, row);
      this.getTableData(row.driverId);
      this.dialogObj.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
.custom-form-1 {
  ::v-deep .table-container .table-box {
    flex-direction: row;
  }
}
</style>
